var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ARTWORK",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.75px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.43,13.55,14.26,8.71a.51.51,0,0,0-.53-.06A4,4,0,0,1,12,9a4,4,0,0,1-1.73-.35.51.51,0,0,0-.53.06L3.57,13.55a.5.5,0,0,0,.08.84C4.77,15,7.39,16,12,16s7.23-1,8.35-1.61A.5.5,0,0,0,20.43,13.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.26,8.71a3.1,3.1,0,0,0-.53-.36A4,4,0,0,0,12,8a4,4,0,0,0-1.73.35,3.1,3.1,0,0,0-.53.36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,11a12,12,0,0,0,5,1,11.75,11.75,0,0,0,5-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCone);
export default __webpack_public_path__ + "static/media/cone.6dc081b2cf2f718e2d14901c9275e734.svg";
export { ForwardRef as ReactComponent };